<template>
  <el-drawer
    ref="drawer"
    :title="$t('Menu.SettingsAndTools')"
    :visible="innerVisible"
    size="36%"
    custom-class="setting-and-tools-drawer"
    :modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('Tool.UserInfo')" name="personalInfo">
        <personal-info-form ref="personalInfo" />
      </el-tab-pane>
      <el-tab-pane :label="$t('Tool.Individual')" name="personalization" lazy>
        <page-personalization ref="personal" />
      </el-tab-pane>
      <el-tab-pane v-if="isAdmin||isDelegation||(!isAdmin && !isDelegation)" :label="$t('Tool.Authorize')" name="delegate" lazy>
        <delegate-info-form :is-delegation.sync="isDelegation" />
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>
<script>
import PersonalInfoForm from './personalInfoForm'
import DelegateInfoForm from './delegateInfoForm'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { mapGetters } from 'vuex'
import PagePersonalization from '@/components/Cargo/Common/NavbarMenu/components/SettingAndTools/PagePersonalization'
export default {
  name: 'SettingAndTools',
  components: { PagePersonalization, PersonalInfoForm, DelegateInfoForm },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isDelegation: false, // 是否已经授权
      innerVisible: false,
      activeName: 'personalInfo'
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'userInfo',
      'isAdmin'
    ])
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.personalInfo.getPersonalEmail()
          this.$refs.personalInfo.initDataService()
          if (this.$refs.personal && this.$refs.personal.$refs.color) {
            this.$refs.personal.$refs.color.reloadType()
          }
        })
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    const localDelegationInfo = LocalStorageUtils.getDelegationInfo()
    if (localDelegationInfo.sessionId === this.userInfo.sessionId) {
      this.isDelegation = true
    } else {
      this.isDelegation = false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleTabClick(e) {
      console.log('tabclick', e)
      // this.$nextTick(() => {
      //   e.$children[0].reload()
      // })
    }
  }
}
</script>
<style lang="scss">
.setting-and-tools-drawer{
  width: 534px;
  font-size:16px;
  .el-drawer__header{
    margin-bottom: 10px;
  }
  .el-drawer__body{
    padding:15px;
  }
}
</style>
